// How A4 words a visit to an owner's dashboard and what it changed (UC-64).
// The server says how each visit ended; the page only names it.

import type { components } from '../api/types';
import { copy } from './copy';
import { instantTime } from './format';

export type Visit = components['schemas']['AdminVisitBody'];
export type VisitAction = components['schemas']['VisitActionBody'];

/** "Left", "Ended at its hour", or "Open until 15:20". */
export function visitEnd(visit: Pick<Visit, 'end' | 'endsAt'>): string {
	switch (visit.end) {
		case 'open':
			return copy.visitOpenUntil(instantTime(visit.endsAt));
		case 'signed_out':
			return copy.visitLeft;
		case 'reset':
			return copy.visitReset;
		case 'expired':
			return copy.visitExpired;
		case 'removed':
			return copy.visitRemoved;
		default:
			// A kind a newer server added: shown as it came, never hidden.
			return String(visit.end);
	}
}

/** "14:20–14:52": from the link's use to its end, or its hour's end while open. */
export function visitSpan(visit: Pick<Visit, 'startedAt' | 'endedAt' | 'endsAt'>): string {
	return `${instantTime(visit.startedAt)}–${instantTime(visit.endedAt ?? visit.endsAt)}`;
}

/** "POST /api/owner/menu/categories", or the words for the start of adding a Google account. */
export function visitChange(action: Pick<VisitAction, 'method' | 'path'>): string {
	if (action.method === 'GET' && action.path === '/auth/google/link') return copy.startedGoogleLink;
	return `${action.method} ${action.path}`;
}

/** The answer's status, or a dash while it is not known. */
export function visitStatus(action: Pick<VisitAction, 'status'>): string {
	return action.status === undefined ? '—' : String(action.status);
}
